import { useTranslation } from '../../contexts/TranslationContext';
import { colors } from '../../theme/colors';
import { Box } from '../primitives/Box';
import { Text } from '../primitives/Text';

interface TriggerWorkflowButtonProps {
  onPress: () => void;
  disabled?: boolean;
}

export const TriggerWorkflowButton = ({
  onPress,
  disabled = false,
}: TriggerWorkflowButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box
      pressable
      onPress={onPress}
      disabled={disabled}
      backgroundColor={disabled ? colors.primary[700] : colors.primary[500]}
      borderRadius="md"
      padding="md"
      alignItems="center"
      minHeight={48}
      justifyContent="center"
      opacity={disabled ? 0.6 : 1}
      accessibilityLabel={t('workflow.title')}
      accessibilityRole="button"
      accessibilityState={{ disabled }}
    >
      <Text variant="body" color={colors.primary[900]} weight="semibold">
        {t('workflow.title')}
      </Text>
    </Box>
  );
};
